import { apiClient } from './api'

export interface Inspection {
  id: string
  yardId: string | number
  inspectionDate: string
  veryGoodCount?: number
  goodCount?: number
  normalCount?: number
  badCount?: number
  population?: number
  populationCount?: number
  populationRating?: 'strong' | 'medium' | 'weak'
  brood?: number
  hasFlowering?: boolean
  notes?: string
  userId?: string | number
  createdAt?: string
}

export interface CreateInspectionPayload {
  yardId: string | number
  inspectionDate: string
  veryGoodCount?: number
  goodCount?: number
  normalCount?: number
  badCount?: number
  population?: number
  brood?: number
  hasFlowering?: boolean
  notes?: string
  userId?: string | number
}

/**
 * Gets inspections
 * @param params - Query params
 * @returns Promise with inspection list
 */
export function getInspections(params?: { yardId?: string | number }) {
  return apiClient.get<Inspection[]>('/inspections', { params })
}

/**
 * Creates a new inspection
 * @param payload - Inspection payload
 * @returns Promise with inspection
 */
export function createInspection(payload: CreateInspectionPayload) {
  return apiClient.post<Inspection>('/inspections', payload)
}

/**
 * Gets inspection statistics for a yard
 * @param yardId - Yard ID
 * @returns Promise with inspection stats
 */
export function getInspectionStats(yardId: string) {
  return apiClient.get<{
    veryGood: number
    good: number
    normal: number
    bad: number
    total: number
    lastInspectionDate: string | null
    hasFlowering: boolean
    notes: string
  }>(`/inspections/stats/${yardId}`)
}
